document.addEventListener("DOMContentLoaded", function(){

    const videoElementContainer = document.querySelector(".video-section");
    const nfImageOrVideoTwoColumnContainer = document.querySelector(".nf-image-or-video-two-column-container");
    const nfImageWIthTextContainer = document.querySelector(".nf-image-with-text-2nd-image");
    const nfImageOrVideoWithTextVideoContainer = document.querySelector(".nf-image-or-video-with-text-video-container");

    function intersectionObserverVideoElement(observingElement, videoEle, videoPlayButton){

      const IntersectionObserverVideoElement = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            
            const playButtonVIdeoElement = document.querySelectorAll(videoPlayButton);

            playButtonVIdeoElement.forEach((videoPlay) => {
    
              videoPlay.addEventListener("click", function(event) {
                const videoElement = document.querySelectorAll(videoEle);

                if(videoElement != null) {
                  videoElement.forEach((video) => {
                      video.play();
                  })
                }

              });

              var videoEvent = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': true
              });

              videoPlay.dispatchEvent(videoEvent);

            });

            //console.log({'element observing': observingElement})

          }
        });
      });
      
      const elementToObserve = document.querySelector(observingElement);
      IntersectionObserverVideoElement.observe(elementToObserve);
    }
    
    if(videoElementContainer != null){
      /* video.liquid */
      intersectionObserverVideoElement(".video-section", ".video-element", ".video-element-button");
    }
    
    if(nfImageOrVideoTwoColumnContainer != null){
      /* NF-image-or-video-two-column.liquid */
      intersectionObserverVideoElement(".nf-image-or-video-two-column-container", ".nf-image-or-video-two-column-video", ".nf-image-or-video-two-column-button");
    }
    if(nfImageWIthTextContainer != null){
      /* NF-image-with-text.liquid */
      intersectionObserverVideoElement(".nf-image-with-text-2nd-image", ".nf-image-or-video-two-column-video", ".nf-image-or-video-two-column-button");
    }
    if(nfImageOrVideoWithTextVideoContainer != null) {
      /* NF-image-or-video-with-text.liquid */
      intersectionObserverVideoElement(".nf-image-or-video-with-text-video-container", ".nf-image-or-video-video", ".video-card-button");
    }

});